export default {
  code: { defaultValue: '' },
  description: { defaultValue: '' },
  type: { defaultValue: 'HT' },
  is_active: { defaultValue: true }
}
